import snukReducer from './snukReducer';

export const activeAlarms = (state, action) => snukReducer(state, action, 'activeAlarms');
export const completedAlarms = (state, action) => snukReducer(state, action, 'completedAlarms');

// export const activeAlarms = (state, action) => {
//   const initState = {
//     isPending: true,
//     isLoadingMore: true,
//     didInvalidate: false,
//     byId: {},
//     allIds: [],
//     nextPageCursor: null,
//   };
//
//   switch (action.type) {
//     case SAVE_ACTIVE_ALARMS:
//       return {
//         ...state,
//         isPending: false,
//         isLoadingMore: false,
//         byId: { ...state.byId, ...action.payload.alarms.entities.alarms },
//         allIds: [...state.allIds, ...action.payload.alarms.result],
//         nextPageCursor: action.payload.cursor || null,
//       };
//     case INVALIDATE_ACTIVE_ALARMS:
//       return {
//         ...state,
//         isPending: false,
//         didInvalidate: false,
//       };
//     case LOAD_MORE_ACTIVE_ALARMS:
//       return {
//         ...state,
//         isLoadingMore: true,
//       };
//     case CLEAR_ALARMS_TABLES:
//       return initState;
//     default:
//       return state || initState;
//   }
// };
//
// export const completedAlarms = (state, action) => {
//   const initState = {
//     isPending: true,
//     didInvalidate: false,
//     byId: {},
//     allIds: [],
//     nextPageCursor: null,
//   };
//
//   switch (action.type) {
//     case SAVE_COMPLETED_ALARMS:
//       return {
//         ...initState,
//         isPending: false,
//         isLoadingMore: false,
//         byId: { ...state.byId, ...action.payload.alarms.entities.alarms },
//         allIds: [...state.allIds, ...action.payload.alarms.result],
//         nextPageCursor: action.payload.cursor || null,
//       };
//     case INVALIDATE_COMPLETED_ALARMS:
//       return {
//         ...initState,
//         isPending: false,
//         didInvalidate: false,
//       };
//     case LOAD_MORE_COMPLETED_ALARMS:
//       return {
//         ...state,
//         isLoadingMore: true,
//       };
//     case CLEAR_ALARMS_TABLES:
//       return initState;
//     default:
//       return state || initState;
//   }
// };



// WEBPACK FOOTER //
// ./src/reducers/alarms.js